<template>
  <path d="M1 16.0308C1 17.1308 1.9 18.0308 3 18.0308H11C12.1 18.0308 13 17.1308 13 16.0308V4.03076H1V16.0308ZM3 6.03076H11V16.0308H3V6.03076ZM10.5 1.03076L9.5 0.0307617H4.5L3.5 1.03076H0V3.03076H14V1.03076H10.5Z" fill="#FF5252" />
</template>

<script>
export default {
  name: 'BinIconOutlined',
}
</script>
